import i18n from '@/i18n'
import $store from '@/store/index'

import { apiSecond } from '@/boot/axios'

export const routes = [
	{
		path: '/',
		redirect: (to) => ({ path: '/' + i18n.locale, hash: to.hash }),
	},
	{
		path: '/:lang',
		component: {
			render(c) {
				return c('router-view')
			},
		},
		children: [
			{
				path: 'account',
				component: () => import('@/views/administrator/AdminPage.vue'),
				async beforeEnter(to, from, next) {
					await $store.dispatch('loadFromLocal')
					if (!localStorage.getItem('access_token')) {
						next('/' + i18n.locale + '/login')
						return
					}
					try {
						const response = await apiSecond.get('v1/user')
						if (response.data) {
							if (response.data.role.accesses) {
								$store.commit('SET_USER_OBJECT', response.data)
								$store.commit('getUserRoles', response.data.role.accesses)
								localStorage.setItem('USER_INFO_LOAD_TIME', new Date().getTime())
							}
						}
					} catch (error) {
						if (error?.response?.status === 401) {
							await $store.dispatch('logout')
							next('/' + i18n.locale + '/login')
							return
						}
					}
					const user = $store.getters._getUserObject
					if (user) {
						if (to.meta.accessList && to.meta.accessList.length) {
							next()
						} else {
							next()
						}
					} else {
						next('/login')
					}
				},
				children: [
					{
						path: '/',
						name: 'AccountMain',
						meta: { accessList: [] },
						component: () => import('@/views/account/main/pages/MainPage'),
					},
					{
						path: 'settings/',
						name: 'Settings',
						meta: { accessList: [] },
						component: () => import('@/views/administrator/Settings'),
					},
					{
						path: 'info/',
						name: 'AccountInfo',
						meta: { accessList: ['read_user_info'] },
						component: () => import('@/views/administrator/AccountInfo/index'),
					},
					{
						path: 'users/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'UserManagement',
								meta: { accessList: ['read_user'] },
								component: () => import('@/views/account/users/index'),
							},
							{
								path: 'create',
								name: 'UserManagementAdd',
								meta: {
									accessList: ['change_user'],
								},
								props: {
									statusPage: 'create',
								},
								component: () => import('@/views/account/users/item'),
							},
							{
								path: ':id',
								name: 'UserManagementShow',
								meta: {
									accessList: ['read_user'],
								},
								props: {
									statusPage: 'show',
								},
								component: () => import('@/views/account/users/item'),
							},
							{
								path: ':id/edit',
								name: 'UserManagementEdit',
								meta: {
									accessList: ['change_user'],
								},
								props: {
									statusPage: 'edit',
								},
								component: () => import('@/views/account/users/item'),
							},
						],
					},
					{
						path: 'roles/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'RoleManagement',
								meta: { accessList: ['change_role'] },
								component: () => import('@/views/account/roles/index'),
							},
							{
								path: 'create',
								name: 'RoleManagementAdd',
								meta: { accessList: ['change_role'] },
								component: () => import('@/views/account/roles/create'),
							},
							{
								path: ':id',
								name: 'RoleManagementShow',
								meta: { accessList: ['change_role'] },
								component: () => import('@/views/account/roles/show'),
							},
							{
								path: ':id/edit',
								name: 'RoleManagementEdit',
								meta: { accessList: ['change_role'] },
								component: () => import('@/views/account/roles/edit'),
							},
						],
					},
					{
						path: 'request_registration/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'RequestRegistration',
								meta: { accessList: ['read_user', 'read_register_requests_aqua'] },
								component: () => import('@/views/account/request_registration/index'),
							},
							{
								path: ':id/',
								name: 'requestRegistrationViews',
								meta: { accessList: ['change_user', 'change_register_requests_aqua'] },
								component: () => import('@/views/account/request_registration/show'),
							},
							// {
							// 	path: ':id/edit',
							// 	name: 'requestRegistrationEdits',
							// 	meta: { accessList: ['change_user'] },
							// 	component: () => import('@/views/account/request_registration/edit'),
							// },
						],
					},
					{
						path: 'request_recovery/',
						name: 'RequestRecovery',
						meta: { accessList: ['change_user'] },
						component: () => import('@/views/account/request_recovery/index'),
					},
					{
						path: 'monitoring/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'UserMonitoring1',
								meta: { accessList: ['read_actionlogs'] },
								component: () => import('@/views/account/monitoring/actions'),
							},
						],
					},
					{
						path: 'monitoring-user/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'UserMonitoring2',
								meta: { accessList: ['read_actionlogs'] },
								component: () => import('@/views/account/monitoring/index'),
							},
							{
								path: ':id',
								name: 'UserMonitoringViews',
								meta: { accessList: ['read_actionlogs'] },
								component: () => import('@/views/account/monitoring/show'),
							},
						],
					},
					{
						path: 'hanbooks',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'Handbooks',
								meta: { accessList: ['read_catalog'] },
								component: () => import('@/views/account/handbooks/index'),
							},
							{
								path: 'reservoirs',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: 'HandbooksReservoirsList',
										meta: { accessList: ['read_catalog'] },
										component: () => import('@/views/account/handbooks/reservoirs/index'),
									},
									{
										path: 'create',
										name: 'HandbooksReservoirsCreate',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'create',
										},
										component: () => import('@/views/account/handbooks/reservoirs/item'),
									},
									{
										path: ':id',
										name: 'HandbooksReservoirsShow',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'show',
										},
										component: () => import('@/views/account/handbooks/reservoirs/item'),
									},
									{
										path: ':id/edit',
										name: 'HandbooksReservoirsUpdate',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import('@/views/account/handbooks/reservoirs/item'),
									},
								],
							},
							{
								path: 'districts',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: 'HandbooksDistrictsList',
										meta: { accessList: ['read_catalog'] },
										component: () => import('@/views/account/handbooks/districts/index'),
									},
									{
										path: 'create',
										name: 'HandbooksDistrictsCreate',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'create',
										},
										component: () => import('@/views/account/handbooks/districts/item'),
									},
									{
										path: ':id',
										name: 'HandbooksDistrictsShow',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'show',
										},
										component: () => import('@/views/account/handbooks/districts/item'),
									},
									{
										path: ':id/edit',
										name: 'HandbooksDistrictsUpdate',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import('@/views/account/handbooks/districts/item'),
									},
								],
							},
							{
								path: 'regions',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: 'HandbooksRegionsList',
										meta: { accessList: ['read_catalog'] },
										component: () => import('@/views/account/handbooks/regions/index'),
									},
									{
										path: 'create',
										name: 'HandbooksRegionsCreate',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'create',
										},
										component: () => import('@/views/account/handbooks/regions/item'),
									},
									{
										path: ':id',
										name: 'HandbooksRegionsShow',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'show',
										},
										component: () => import('@/views/account/handbooks/regions/item'),
									},
									{
										path: ':id/edit',
										name: 'HandbooksRegionsUpdate',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import('@/views/account/handbooks/regions/item'),
									},
								],
							},
							{
								path: 'catch-types',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: 'HandbooksCatchTypesList',
										meta: { accessList: ['read_catalog'] },
										component: () => import('@/views/account/handbooks/catch-types/index'),
									},
									{
										path: 'create',
										name: 'HandbooksCatchTypesCreate',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'create',
										},
										component: () => import('@/views/account/handbooks/catch-types/item'),
									},
									{
										path: ':id',
										name: 'HandbooksCatchTypesShow',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'show',
										},
										component: () => import('@/views/account/handbooks/catch-types/item'),
									},
									{
										path: ':id/edit',
										name: 'HandbooksCatchTypesUpdate',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import('@/views/account/handbooks/catch-types/item'),
									},
								],
							},
							{
								path: 'pools',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: 'HandbooksPoolsList',
										meta: { accessList: ['read_catalog'] },
										component: () => import('@/views/account/handbooks/pools/index'),
									},
									{
										path: 'create',
										name: 'HandbooksPoolsCreate',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'create',
										},
										component: () => import('@/views/account/handbooks/pools/item'),
									},
									{
										path: ':id',
										name: 'HandbooksPoolsShow',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'show',
										},
										component: () => import('@/views/account/handbooks/pools/item'),
									},
									{
										path: ':id/edit',
										name: 'HandbooksPoolsUpdate',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import('@/views/account/handbooks/pools/item'),
									},
								],
							},
							{
								path: 'plots',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: 'HandbooksPlotsList',
										meta: { accessList: ['read_catalog'] },
										component: () => import('@/views/account/handbooks/plots/index'),
									},
									{
										path: 'create',
										name: 'HandbooksPlotsCreate',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'create',
										},
										component: () => import('@/views/account/handbooks/plots/item'),
									},
									{
										path: ':id',
										name: 'HandbooksPlotsShow',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'show',
										},
										component: () => import('@/views/account/handbooks/plots/item'),
									},
									{
										path: ':id/edit',
										name: 'HandbooksPlotsUpdate',
										meta: { accessList: ['read_catalog'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import('@/views/account/handbooks/plots/item'),
									},
								],
							},
						],
					},
					{
						path: 'limits/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'LimitManagement1',
								meta: { accessList: ['read_limit'] },
								component: () => import('@/views/account/limits/index'),
							},
							{
								path: 'create',
								name: 'LimitManagementAdd',
								meta: { accessList: ['change_limit'] },
								component: () => import('@/views/account/limits/create'),
							},
							{
								path: ':id',
								name: 'LimitManagement2',
								meta: { accessList: ['read_limit'] },
								component: () => import('@/views/account/limits/show'),
							},
							{
								path: ':id/:chapter',
								name: 'LimitManagement3',
								meta: { accessList: ['read_limit'] },
								component: () => import('@/views/account/limits/item-index'),
								beforeEnter: (to, from, next) => {
									//to, from, next
									let roleAccesses = ['republic', 'local'].find((element) => {
										return to.params.chapter.includes(element)
									})
									roleAccesses ? next() : (window.location = '/' + to.params.lang + '/404')
								},
							},
							{
								path: ':id/:chapter/create',
								name: 'LimitManagement5',
								meta: { accessList: ['change_limit'] },
								component: () => import('@/views/account/limits/item-create'),
								beforeEnter: (to, from, next) => {
									//to, from, next
									let roleAccesses = ['republic', 'local'].find((element) => {
										return to.params.chapter.includes(element)
									})
									roleAccesses ? next() : (window.location = '/' + to.params.lang + '/404')
								},
							},
							{
								path: ':id/:chapter/:itemId/edit',
								name: 'LimitManagement6',
								meta: { accessList: ['change_limit'] },
								component: () => import('@/views/account/limits/item-edit'),
								beforeEnter: (to, from, next) => {
									//to, from, next
									let roleAccesses = ['republic', 'local'].find((element) => {
										return to.params.chapter.includes(element)
									})
									roleAccesses ? next() : (window.location = '/' + to.params.lang + '/404')
								},
							},
							{
								path: ':id/:chapter/:itemId',
								name: 'LimitManagement',
								meta: { accessList: ['read_limit'] },
								component: () => import('@/views/account/limits/item-show'),
								beforeEnter: (to, from, next) => {
									//to, from, next
									let roleAccesses = ['republic', 'local'].find((element) => {
										return to.params.chapter.includes(element)
									})
									roleAccesses ? next() : (window.location = '/' + to.params.lang + '/404')
								},
							},
						],
					},
					{
						path: 'quotas/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'QuotaManagement1',
								meta: { accessList: ['read_quota'] },
								component: () => import('@/views/account/quotas/index'),
							},
							{
								path: 'create',
								name: 'QuotaManagement2',
								meta: { accessList: ['change_quota'] },
								component: () => import('@/views/account/quotas/create'),
							},
							{
								path: ':id',
								name: 'QuotaManagement3',
								meta: { accessList: ['change_quota'], isView: true },
								component: () => import('@/views/account/quotas/create'),
							},
							{
								path: ':id/edit',
								name: 'QuotaManagementEdit3',
								meta: { accessList: ['change_quota'], isEdit: true },
								component: () => import('@/views/account/quotas/create'),
							},
							{
								path: ':id/list',
								name: 'QuotaManagement4',
								meta: { accessList: ['read_quota'] },
								component: () => import('@/views/account/quotas/item-index'),
							},
							{
								path: ':id/item/create',
								name: 'QuotaManagement55',
								meta: { accessList: ['change_quota'] },
								component: () => import('@/views/account/quotas/item-create'),
							},
							{
								path: ':id/item/:itemId',
								name: 'QuotaManagement6',
								meta: { accessList: ['read_quota'] },
								component: () => import('@/views/account/quotas/item-show'),
							},
							{
								path: ':id/item/:itemId/edit',
								name: 'QuotaManagement7',
								meta: { accessList: ['read_quota'] },
								component: () => import('@/views/account/quotas/item-edit'),
							},
						],
					},
					{
						path: 'design_capacity/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'DesignCapacity1',
								meta: { accessList: ['read_quota'] },
								component: () => import('@/views/account/design_capacity/index'),
							},
							{
								path: 'create',
								name: 'DesignCapacity2',
								meta: { accessList: ['change_quota'] },
								component: () => import('@/views/account/design_capacity/create'),
							},
							{
								path: ':id',
								name: 'DesignCapacity3',
								meta: { accessList: ['change_quota'], isView: true },
								component: () => import('@/views/account/design_capacity/create'),
							},
							{
								path: ':id/edit',
								name: 'DesignCapacityEdit3',
								meta: { accessList: ['change_quota'], isEdit: true },
								component: () => import('@/views/account/design_capacity/create'),
							},
							{
								path: ':id/list',
								name: 'DesignCapacity4',
								meta: { accessList: ['read_quota'] },
								component: () => import('@/views/account/design_capacity/item-index'),
							},
							{
								path: ':id/item/create',
								name: 'DesignCapacity5',
								meta: { accessList: ['change_quota'] },
								component: () => import('@/views/account/design_capacity/item-create'),
							},
							{
								path: ':id/item/:itemId',
								name: 'DesignCapacity6',
								meta: { accessList: ['read_quota'] },
								component: () => import('@/views/account/design_capacity/item-show'),
							},
							{
								path: ':id/item/:itemId/edit',
								name: 'DesignCapacity7',
								meta: { accessList: ['read_quota'] },
								component: () => import('@/views/account/design_capacity/item-edit'),
							},
						],
					},
					{
						path: 'zpm/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'Zpm1',
								meta: { accessList: ['read_zpm'] },
								component: () => import('@/views/account/zpm/index'),
							},
							{
								path: 'create',
								name: 'Zpm2',
								meta: { accessList: ['change_zpm'] },
								component: () => import('@/views/account/zpm/create'),
							},
							{
								path: ':id',
								name: 'Zpm3',
								meta: { accessList: ['read_zpm'], isView: true },
								component: () => import('@/views/account/zpm/create'),
							},
							{
								path: ':id/edit',
								name: 'Zpm4',
								meta: { accessList: ['change_zpm'], isEdit: true },
								component: () => import('@/views/account/zpm/create'),
							},
						],
					},
					{
						path: 'aqua-analytics',
						name: 'AquaAnalytics',
						meta: { accessList: ['read_analytics-aqua'] },
						component: () => import('@/views/account/aqua-analytics/index'),
					},
					{
						path: 'zpm-my/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'ZpmMy1',
								meta: { accessList: ['read_virtual_warehouse'] },
								component: () => import('@/views/account/zpm/my'),
							},
							{
								path: ':id',
								name: 'ZpmMy2',
								meta: { accessList: ['read_virtual_warehouse'], isView: true, subject: true },
								component: () => import('@/views/account/zpm/create'),
							},
						],
					},
					{
						path: 'quotas-reverse/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'QuotaReverseManagement1',
								meta: { accessList: ['read_quota-reverse'] },
								component: () => import('@/views/account/quotas-reverse/index'),
							},
							{
								path: ':id/list',
								name: 'QuotaReverseManagement2',
								meta: { accessList: ['read_quota-reverse'] },
								component: () => import('@/views/account/quotas-reverse/item-index'),
							},
							{
								path: ':id/item/create',
								name: 'QuotaReverseManagement3',
								meta: { accessList: ['read_quota-reverse'] },
								component: () => import('@/views/account/quotas-reverse/item-create'),
							},
							{
								path: ':id/item/:itemId',
								name: 'QuotaReverseManagement4',
								meta: { accessList: ['read_quota-reverse'] },
								component: () => import('@/views/account/quotas-reverse/item-show'),
							},
						],
					},
					{
						path: 'documents/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'DocumentManagement1',
								meta: { accessList: ['read_document', 'read_document_all'] },
								component: () => import('@/views/account/documents/index'),
							},
							{
								path: 'create',
								name: 'DocumentManagement2',
								meta: { accessList: ['read_document', 'read_document_all'] },
								props: {
									statusPage: 'create',
								},
								component: () => import('@/views/account/documents/item'),
							},
							{
								path: ':id',
								name: 'DocumentManagementShow',
								meta: { accessList: ['read_document', 'read_document_all'] },
								props: {
									statusPage: 'show',
								},
								component: () => import('@/views/account/documents/item'),
							},
							{
								path: ':id/edit',
								name: 'DocumentManagementEdit',
								meta: { accessList: ['read_document', 'read_document_all'] },
								props: {
									statusPage: 'edit',
								},
								component: () => import('@/views/account/documents/item'),
							},
						],
					},
					{
						path: 'documents-list/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'DocumentManagementSupervisor1',
								meta: { accessList: ['read_document_all'] },
								component: () => import('@/views/account/documents-list/index'),
							},
							{
								path: ':userId/list',
								name: 'DocumentManagementSupervisor2',
								meta: { accessList: ['read_document_all'] },
								component: () => import('@/views/account/documents-list/item-index'),
							},
						],
					},
					{
						path: 'logs/',
						name: 'LogsManagement',
						meta: { accessList: [] },
						component: () => import('@/views/account/logs/index'),
						children: [
							{
								path: 'grown/',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: 'GrownList',
										meta: { accessList: ['read_grown'] },
										component: () => import('@/views/account/logs/GrownManagement/index'),
									},
									{
										path: 'create',
										name: 'GrownCreate',
										meta: { accessList: ['change_grown'] },
										component: () => import('@/views/account/logs/GrownManagement/create'),
									},
									{
										path: ':id',
										name: 'GrownShow',
										meta: { accessList: ['read_grown'] },
										props: {
											statusPage: 'show',
										},
										component: () => import('@/views/account/logs/GrownManagement/create'),
									},
									{
										path: ':id/edit',
										name: 'GrownEdit',
										meta: { accessList: ['change_grown'] },
										component: () => import('@/views/account/logs/GrownManagement/create'),
									},
								],
							},
							{
								path: 'purchased/',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: 'PurchasedManagement1',
										meta: { accessList: ['read_purchased'] },
										component: () => import('@/views/account/logs/PurchasedManagement/index'),
									},
									{
										path: 'create',
										name: 'PurchasedManagement2',
										meta: { accessList: ['change_purchased'] },
										component: () => import('@/views/account/logs/PurchasedManagement/create'),
									},
									{
										path: ':id',
										name: 'PurchasedManagement3',
										meta: { accessList: ['read_purchased'] },
										component: () => import('@/views/account/logs/PurchasedManagement/show'),
									},
								],
							},
							{
								path: 'implemented/',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: 'ImplementedManagement1',
										meta: { accessList: ['read_implemented'] },
										component: () => import('@/views/account/logs/ImplementedManagement/index'),
									},
									{
										path: 'create',
										name: 'ImplementedManagement2',
										meta: { accessList: ['change_implemented'] },
										component: () => import('@/views/account/logs/ImplementedManagement/create'),
									},
									{
										path: ':id',
										name: 'ImplementedManagement3',
										meta: { accessList: ['read_implemented'] },
										component: () => import('@/views/account/logs/ImplementedManagement/show'),
									},
								],
							},
						],
					},
					{
						path: 'virtual-warehouse/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'VirtualWarehouse',
								meta: { accessList: ['read_virtual_warehouse'] },
								component: () => import('@/views/account/virtual-warehouse/index'),
							},
							{
								path: 'history',
								name: 'VirtualWarehouseHistory',
								meta: { accessList: ['read_virtual_warehouse'] },
								component: () => import('@/views/account/virtual-warehouse/history'),
							},
							{
								path: 'process',
								name: 'VirtualWarehouseProcess',
								meta: { accessList: ['read_virtual_warehouse'] },
								component: () => import('@/views/account/virtual-warehouse/process'),
							},
						],
					},
					{
						path: 'brigade',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'brigade-list',
								meta: {
									accessList: ['read_trade', 'read_grown', 'read_purchased', 'read_implemented'],
								},
								component: () => import('@/views/account/brigade/index'),
							},
							{
								path: 'create',
								name: 'brigade-create',
								meta: {
									accessList: ['read_trade', 'read_grown', 'read_purchased', 'read_implemented'],
								},
								component: () => import('@/views/account/brigade/item'),
							},
							{
								path: ':id',
								name: 'brigade-show',
								meta: {
									accessList: ['read_trade', 'read_grown', 'read_purchased', 'read_implemented'],
								},
								props: {
									statusPage: 'show',
								},
								component: () => import('@/views/account/brigade/item'),
							},
							{
								path: ':id/edit',
								name: 'brigade-edit',
								meta: {
									accessList: ['read_trade', 'read_grown', 'read_purchased', 'read_implemented'],
								},
								component: () => import('@/views/account/brigade/item'),
							},
						],
					},
					{
						// «Мои орудия лова» — сводка орудий по разрешениям eLicense в личном кабинете
						// субъекта, поэтому доступ по declarer_menu (это меню только у роли субъекта).
						path: 'gears/',
						name: 'MyGears',
						meta: { accessList: ['declarer_menu'] },
						component: () => import('@/views/account/gears/index'),
					},
					{
						path: 'fishing-permit',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'fishing-permit',
								meta: {
									accessList: ['read_trade', 'read_grown', 'read_purchased', 'read_implemented'],
								},
								component: () => import('@/views/account/fishing-permit/index'),
							},
							{
								path: ':id',
								name: 'fishing-permit-show',
								meta: {
									accessList: ['read_trade', 'read_grown', 'read_purchased', 'read_implemented'],
								},
								props: {
									statusPage: 'show',
								},
								component: () => import('@/views/account/fishing-permit/item'),
							},
							{
								path: ':id/edit',
								name: 'fishing-permit-edit',
								meta: {
									accessList: ['read_trade', 'read_grown', 'read_purchased', 'read_implemented'],
								},
								component: () => import('@/views/account/fishing-permit/item'),
							},
						],
					},
					{
						path: 'register/data',
						name: 'DataRegister',
						// meta: { accessList: ["change_trade"] },
						component: () => import('@/views/administrator/DataRegister/index'),
					},
					{
						path: 'notifications',
						name: 'Notifications',
						// meta: { accessList: ["change_trade"] },
						component: () => import('@/views/account/notifications'),
					},
					{
						path: 'trade-list/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'TradeManagementSupervisor1',
								meta: { accessList: ['read_trade_all'] },
								component: () => import('@/views/account/trade-list/index'),
							},
							{
								path: ':userId/list',
								name: 'TradeManagementSupervisor2',
								meta: { accessList: ['read_trade_all'] },
								component: () => import('@/views/account/trade-list/item-index'),
							},
							{
								path: ':userId/list/:id',
								name: 'TradeManagementSupervisor3',
								meta: { accessList: ['read_trade_all'] },
								component: () => import('@/views/account/trade-list/item-show'),
							},
							{
								path: ':userId/user-profile',
								name: 'TradeManagementSupervisor4',
								meta: { accessList: ['read_trade_all'] },
								component: () => import('@/views/account/trade-list/user-profile'),
							},
						],
					},
					{
						path: 'register-list/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'DataRegisterSupervisor1',
								meta: { accessList: ['read_data_register_all'] },
								component: () => import('@/views/account/register-list/index'),
							},
							{
								path: ':userId/list',
								name: 'DataRegisterSupervisor2',
								meta: { accessList: ['read_data_register_all'] },
								component: () => import('@/views/account/register-list/item-index'),
							},
						],
					},
					{
						path: 'reporting-list/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'ReportingManagementSupervisor1',
								meta: { accessList: ['read_reporting_all'] },
								component: () => import('@/views/account/reporting-list/index'),
							},
							{
								path: ':itemId',
								name: 'ReportingManagementSupervisor2',
								meta: { accessList: ['read_reporting_all'] },
								component: () => import('@/views/account/reporting-list/list-index'),
							},
							{
								path: '1/user/:userId/list',
								name: 'ReportingManagementSupervisor3',
								meta: { accessList: ['read_reporting_all'] },
								component: () => import('@/views/account/reporting-list/list/px-1/item-list'),
							},
							{
								path: ':itemId/user/:userId/list',
								name: 'ReportingManagementSupervisor4',
								meta: { accessList: ['read_reporting_all'] },
								component: () => import('@/views/account/reporting-list/list/one/item-list'),
							},
						],
					},
					{
						path: 'reporting-analytics/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'reporting-analytics-index',
								meta: { accessList: ['read_reporting_all'] },
								beforeEnter: (to, from, next) => {
									const user = $store.getters._getUserObject
									if (user && user.role) {
										const roleName = user.role.name

										// Redirect based on user role
										if (roleName === 'go' || roleName === 'go_manager' || roleName === 'go_check') {
											next('/' + to.params.lang + '/account/reporting-analytics/go')
										} else if (roleName === 'tir') {
											next('/' + to.params.lang + '/account/reporting-analytics/tir')
										} else {
											// Default to GO for other roles
											next('/' + to.params.lang + '/account/reporting-analytics/go')
										}
									} else {
										// Default to GO if no role found
										next('/' + to.params.lang + '/account/reporting-analytics/go')
									}
								},
								component: () => import(`@/views/account/reporting/go/index.vue`),
							},
							{
								path: 'go',
								name: 'reporting-analytics-go',
								meta: { accessList: ['read_reporting_all'] },
								component: () => import(`@/views/account/reporting/go/index.vue`),
							},
							{
								path: 'tir',
								name: 'reporting-analytics-tir',
								meta: { accessList: ['read_reporting_all'] },
								component: () => import(`@/views/account/reporting/tir/index.vue`),
							},
							{
								path: '1',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										redirect: 'region',
									},
									{
										path: 'region',
										name: 'reporting-analytics-region-1',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-1/region`),
									},
									{
										path: 'subject',
										name: 'reporting-analytics-subject-1',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-1/subject`),
									},
									{
										path: 'region/admin',
										name: 'reporting-analytics-region-1-admin',
										meta: { accessList: ['change_user'] },
										component: () => import(`@/views/account/reporting/admin/px-1/region`),
									},
								],
							},
							{
								path: '2',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										redirect: 'region',
									},
									{
										path: 'region',
										name: 'reporting-analytics-region-2',
										meta: { accessList: ['read_reporting_all'] },
										beforeEnter: (to, from, next) => {
											const user = $store.getters._getUserObject
											if (user && user.role && user.role.name === 'tir') {
												next()
											} else {
												next('/' + to.params.lang + '/account/reporting-analytics/2/region-go')
											}
										},
										component: () => import(`@/views/account/reporting/tir/2-tir-rh/list`),
									},
									{
										path: 'region-go',
										name: 'reporting-analytics-region-2-go',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-2/region`),
									},
									{
										path: 'subject',
										name: 'reporting-analytics-subject-2',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-2/subject`),
									},
								],
							},
							{
								path: '3',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										redirect: 'region',
									},
									{
										path: 'region',
										name: 'reporting-analytics-region-3',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-3/region`),
									},
									{
										path: 'subject',
										name: 'reporting-analytics-subject-3',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-3/subject`),
									},
								],
							},
							{
								path: '5',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										redirect: 'region',
									},
									{
										path: 'region',
										name: 'reporting-analytics-region-5',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-5/region`),
									},
									{
										path: 'subject',
										name: 'reporting-analytics-subject-5',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-5/subject`),
									},
								],
							},
							{
								path: '6',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										redirect: 'region',
									},
									{
										path: 'region',
										name: 'reporting-analytics-region-6',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-6/region`),
									},
									{
										path: 'subject',
										name: 'reporting-analytics-subject-6',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-6/subject`),
									},
								],
							},
							{
								path: '7',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										redirect: 'region',
									},
									{
										path: 'region',
										name: 'reporting-analytics-region-7',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-7/region`),
									},
									{
										path: 'subject',
										name: 'reporting-analytics-subject-7',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-7/subject`),
									},
								],
							},
							{
								path: '8',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										redirect: 'region',
									},
									{
										path: 'region',
										name: 'reporting-analytics-region-8',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-8/region`),
									},
									{
										path: 'subject',
										name: 'reporting-analytics-subject-8',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-8/subject`),
									},
								],
							},
							{
								path: '9',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										redirect: 'region',
									},
									{
										path: 'region',
										name: 'reporting-analytics-region-9',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-9/region`),
									},
									{
										path: 'subject',
										name: 'reporting-analytics-subject-9',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-9/subject`),
									},
								],
							},
							{
								path: '10',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										redirect: 'region',
									},
									{
										path: 'region',
										name: 'reporting-analytics-region',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-10/region`),
									},
									{
										path: 'subject',
										name: 'reporting-analytics-subject-10',
										meta: { accessList: ['read_reporting_all'] },
										component: () => import(`@/views/account/reporting/go/px-10/subject`),
									},
								],
							},
							{
								path: 'aqua-compliance',
								name: 'aqua-go-compliance',
								meta: { accessList: ['read_reporting-aqua-go'] },
								props: { scope: 'go' },
								component: () => import(`@/views/account/reporting/aqua/compliance`),
							},
							{
								path: 'aqua/:form([1-6])',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: 'aqua-go-list',
										meta: { accessList: ['read_reporting-aqua-go'] },
										props: { scope: 'go' },
										component: () => import(`@/views/account/reporting/aqua/index`),
									},
									{
										path: 'summary',
										name: 'aqua-go-summary',
										meta: { accessList: ['read_reporting-aqua-go'] },
										props: { scope: 'go' },
										component: () => import(`@/views/account/reporting/aqua/summary`),
									},
									{
										path: ':id(\\d+)',
										name: 'aqua-go-show',
										meta: { accessList: ['read_reporting-aqua-go'] },
										props: { scope: 'go', statusPage: 'show' },
										component: () => import(`@/views/account/reporting/aqua/AquaReportPage`),
									},
								],
							},
						],
					},
					{
						path: 'monitoring-for-tir/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'monitoring-for-tir',
								meta: { accessList: ['read_monitoring'] },
								component: () => import(`@/views/account/monitoring-for-tir/pages/index.vue`),
							},
						],
					},
					{
						path: 'monitoring-subjects/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'monitoring-subjects',
								meta: { accessList: ['read_monitoring'] },
								component: () => import(`@/views/account/monitoring-subjects/pages/index.vue`),
							},
						],
					},
					{
						path: 'logs-analytics/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: 'fishing-log',
								name: 'logs-analytics-fishing-log',
								meta: { accessList: ['read_analytic_trade'] },
								component: () => import(`@/views/account/logs-analytics/fishing-log.vue`),
							},
						],
					},
					{
						path: 'reporting',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'Reporting',
								meta: { accessList: ['read_reporting'] },
								component: () => import('@/views/account/reporting/index'),
							},
							{
								path: '1-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '1-rh-list',
										meta: { accessList: ['read_reporting-1rh'] },
										component: () => import('@/views/account/reporting/subject/1-rh/index'),
									},
									{
										path: 'create',
										name: '1-rh-create',
										meta: { accessList: ['change_reporting-1rh'] },
										props: {
											statusPage: 'create',
										},
										component: () => import('@/views/account/reporting/subject/1-rh/ReportPage1'),
									},
									{
										path: ':id',
										name: '1-rh-show',
										meta: { accessList: ['change_reporting-1rh'] },
										props: {
											statusPage: 'show',
										},
										component: () => import('@/views/account/reporting/subject/1-rh/ReportPage1'),
									},
									{
										path: ':id/edit',
										name: '1-rh-edit',
										meta: { accessList: ['change_reporting-1rh'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import('@/views/account/reporting/subject/1-rh/ReportPage1'),
									},
								],
							},
							{
								path: '1-rh-mini',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '1-rh-mini-list',
										meta: { accessList: ['read_reporting-1rh'] },
										component: () =>
											import(`@/views/account/reporting/subject/1-rh-mini/List1Mini`),
									},
									{
										path: 'create',
										name: '1-rh-mini-create',
										meta: { accessList: ['change_reporting-1rh'] },
										props: {
											statusPage: 'create',
										},
										component: () =>
											import(`@/views/account/reporting/subject/1-rh-mini/ReportPage1Mini`),
									},
									{
										path: ':id',
										name: '1-rh-mini-show',
										meta: { accessList: ['change_reporting-1rh'] },
										props: {
											statusPage: 'show',
										},
										component: () =>
											import(`@/views/account/reporting/subject/1-rh-mini/ReportPage1Mini`),
									},
									{
										path: ':id/edit',
										name: '1-rh-mini-edit',
										meta: { accessList: ['change_reporting-1rh'] },
										props: {
											statusPage: 'edit',
										},
										component: () =>
											import(`@/views/account/reporting/subject/1-rh-mini/ReportPage1Mini`),
									},
								],
							},
							{
								path: '2-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '2-rh-list',
										meta: { accessList: ['read_reporting-2rh'] },
										component: () => import(`@/views/account/reporting/subject/2-rh/index`),
									},
									{
										path: 'create',
										name: '2-rh-create',
										meta: { accessList: ['change_reporting-2rh'] },
										props: {
											statusPage: 'create',
										},
										component: () => import(`@/views/account/reporting/subject/2-rh/ReportPage2`),
									},
									{
										path: ':id',
										name: '2-rh-show',
										meta: { accessList: ['change_reporting-2rh'] },
										props: {
											statusPage: 'show',
										},
										component: () => import(`@/views/account/reporting/subject/2-rh/ReportPage2`),
									},
									{
										path: ':id/edit',
										name: '2-rh-edit',
										meta: { accessList: ['change_reporting-2rh'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import(`@/views/account/reporting/subject/2-rh/ReportPage2`),
									},
								],
							},
							{
								path: '3-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '3-rh-list',
										meta: { accessList: ['read_reporting-3rh'] },
										component: () => import(`@/views/account/reporting/subject/3-rh/index`),
									},
									{
										path: 'create',
										name: '3-rh-create',
										meta: { accessList: ['change_reporting-3rh'] },
										props: {
											statusPage: 'create',
										},
										component: () => import(`@/views/account/reporting/subject/3-rh/ReportPage3`),
									},
									{
										path: ':id',
										name: '3-rh-show',
										meta: { accessList: ['change_reporting-3rh'] },
										props: {
											statusPage: 'show',
										},
										component: () => import(`@/views/account/reporting/subject/3-rh/ReportPage3`),
									},
									{
										path: ':id/edit',
										name: '3-rh-edit',
										meta: { accessList: ['change_reporting-3rh'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import(`@/views/account/reporting/subject/3-rh/ReportPage3`),
									},
								],
							},
							{
								path: '7-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '7-rh-list',
										meta: { accessList: ['read_reporting-7rh'] },
										component: () => import(`@/views/account/reporting/subject/7-rh/index`),
									},
									{
										path: 'create',
										name: '7-rh-create',
										meta: { accessList: ['change_reporting-7rh'] },
										props: {
											statusPage: 'create',
										},
										component: () => import(`@/views/account/reporting/subject/7-rh/ReportPage7`),
									},
									{
										path: ':id',
										name: '7-rh-show',
										meta: { accessList: ['change_reporting-7rh'] },
										props: {
											statusPage: 'show',
										},
										component: () => import(`@/views/account/reporting/subject/7-rh/ReportPage7`),
									},
									{
										path: ':id/edit',
										name: '7-rh-edit',
										meta: { accessList: ['change_reporting-7rh'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import(`@/views/account/reporting/subject/7-rh/ReportPage7`),
									},
								],
							},
							{
								path: '8-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '8-rh-list',
										meta: { accessList: ['read_reporting-8rh'] },
										component: () => import(`@/views/account/reporting/subject/8-rh/index`),
									},
									{
										path: 'create',
										name: '8-rh-create',
										meta: { accessList: ['change_reporting-8rh'] },
										props: {
											statusPage: 'create',
										},
										component: () => import(`@/views/account/reporting/subject/8-rh/ReportPage8`),
									},
									{
										path: ':id',
										name: '8-rh-show',
										meta: { accessList: ['change_reporting-8rh'] },
										props: {
											statusPage: 'show',
										},
										component: () => import(`@/views/account/reporting/subject/8-rh/ReportPage8`),
									},
									{
										path: ':id/edit',
										name: '8-rh-edit',
										meta: { accessList: ['change_reporting-8rh'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import(`@/views/account/reporting/subject/8-rh/ReportPage8`),
									},
								],
							},
							{
								path: '9-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '9-rh-list',
										meta: { accessList: ['read_reporting-9rh'] },
										component: () => import(`@/views/account/reporting/subject/9-rh/index`),
									},
									{
										path: 'create',
										name: '9-rh-create',
										meta: { accessList: ['change_reporting-9rh'] },
										props: {
											statusPage: 'create',
										},
										component: () => import(`@/views/account/reporting/subject/9-rh/ReportPage9`),
									},
									{
										path: ':id',
										name: '9-rh-show',
										meta: { accessList: ['change_reporting-9rh'] },
										props: {
											statusPage: 'show',
										},
										component: () => import(`@/views/account/reporting/subject/9-rh/ReportPage9`),
									},
									{
										path: ':id/edit',
										name: '9-rh-edit',
										meta: { accessList: ['change_reporting-9rh'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import(`@/views/account/reporting/subject/9-rh/ReportPage9`),
									},
								],
							},
							{
								path: '10-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '10-rh-list',
										meta: { accessList: ['read_reporting-10rh'] },
										component: () => import(`@/views/account/reporting/subject/10-rh/index`),
									},
									{
										path: 'create',
										name: '10-rh-create',
										meta: { accessList: ['change_reporting-10rh'] },
										props: {
											statusPage: 'create',
										},
										component: () => import(`@/views/account/reporting/subject/10-rh/ReportPage10`),
									},
									{
										path: ':id',
										name: '10-rh-show',
										meta: { accessList: ['change_reporting-10rh'] },
										props: {
											statusPage: 'show',
										},
										component: () => import(`@/views/account/reporting/subject/10-rh/ReportPage10`),
									},
									{
										path: ':id/edit',
										name: '10-rh-edit',
										meta: { accessList: ['change_reporting-10rh'] },
										props: {
											statusPage: 'edit',
										},
										component: () => import(`@/views/account/reporting/subject/10-rh/ReportPage10`),
									},
								],
							},
							{
								path: '1-tir-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '1-tir-rh-index',
										meta: { accessList: ['read_reporting-1-tir-rh'] },
										component: () => import(`@/views/account/reporting/tir/1-tir-rh/index`),
									},
									{
										path: 'list',
										name: '1-tir-rh-list',
										component: {
											render: (h) => h('router-view'),
										},
										children: [
											{
												path: ':id',
												name: '1-tir-rh-archive',
												meta: { accessList: ['change_reporting-1-tir-rh'] },
												props: {
													statusPage: 'list',
												},

												component: () => import(`@/views/account/reporting/tir/1-tir-rh/list`),
											},
										],
									},
									{
										path: 'create',
										name: '1-tir-rh-create',
										//meta: {accessList: ['change_reporting-5rh']},
										props: {
											statusPage: 'create',
										},
										component: () => import(`@/views/account/reporting/tir/1-tir-rh/edit`),
									},
									{
										path: ':id',
										name: '1-tir-rh-show',
										//meta: {accessList: ['change_reporting-5rh']},
										props: {
											statusPage: 'show',
										},
										component: () => import(`@/views/account/reporting/tir/1-tir-rh/edit`),
									},
									{
										path: ':id/edit',
										name: '1-tir-rh-edit',
										//meta: {accessList: ['change_reporting-5rh']},
										props: {
											statusPage: 'edit',
										},
										component: () => import(`@/views/account/reporting/tir/1-tir-rh/edit`),
									},
								],
							},
							{
								path: '2-tir-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '2-tir-rh-index',
										//meta: {accessList: ['read_reporting-5rh']},
										component: () => import(`@/views/account/reporting/tir/2-tir-rh/index`),
									},
									{
										path: 'list',
										name: '2-tir-rh-list',
										component: {
											render: (h) => h('router-view'),
										},
										children: [
											{
												path: ':id',
												name: '2-tir-rh-archive',
												meta: { accessList: ['change_reporting-2-tir-rh'] },
												props: {
													statusPage: 'archive',
												},
												component: () => import(`@/views/account/reporting/tir/2-tir-rh/list`),
											},
										],
									},
									{
										path: 'view/:id',
										name: '2-tir-rh-view',
										component: () => import(`@/views/account/reporting/tir/2-tir-rh/view`),
									},
								],
							},
							{
								path: '3-tir-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '3-tir-rh-index',
										//meta: {accessList: ['read_reporting-5rh']},
										component: () => import(`@/views/account/reporting/tir/3-tir-rh/index`),
									},
									{
										path: 'list',
										name: '3-tir-rh-list',
										component: {
											render: (h) => h('router-view'),
										},
										children: [
											{
												path: ':id',
												name: '3-tir-rh-archive',
												meta: { accessList: ['change_reporting-3-tir-rh'] },
												props: {
													statusPage: 'archive',
												},
												component: () => import(`@/views/account/reporting/tir/3-tir-rh/list`),
											},
										],
									},
								],
							},
							{
								path: '5-tir-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '5-tir-rh-list',
										//meta: {accessList: ['read_reporting-5rh']},
										component: () => import(`@/views/account/reporting/tir/5-tir-rh/index`),
									},
									{
										path: 'create',
										name: '5-tir-rh-create',
										//meta: {accessList: ['change_reporting-5rh']},
										props: {
											statusPage: 'create',
										},
										component: () =>
											import(`@/views/account/reporting/tir/5-tir-rh/ReportPageTir5`),
									},
									{
										path: ':id',
										name: '5-tir-rh-show',
										//meta: {accessList: ['change_reporting-5rh']},
										props: {
											statusPage: 'show',
										},
										component: () =>
											import(`@/views/account/reporting/tir/5-tir-rh/ReportPageTir5`),
									},
									{
										path: ':id/edit',
										name: '5-tir-rh-edit',
										//meta: {accessList: ['change_reporting-5rh']},
										props: {
											statusPage: 'edit',
										},
										component: () =>
											import(`@/views/account/reporting/tir/5-tir-rh/ReportPageTir5`),
									},
								],
							},
							{
								path: '6-tir-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '6-tir-rh-list',
										//meta: {accessList: ['read_reporting-5rh']},
										component: () => import(`@/views/account/reporting/tir/6-tir-rh/index`),
									},
									{
										path: 'create',
										name: '6-tir-rh-create',
										//meta: {accessList: ['change_reporting-5rh']},
										props: {
											statusPage: 'create',
										},
										component: () =>
											import(`@/views/account/reporting/tir/6-tir-rh/ReportPageTir6`),
									},
									{
										path: ':id',
										name: '6-tir-rh-show',
										//meta: {accessList: ['change_reporting-5rh']},
										props: {
											statusPage: 'show',
										},
										component: () =>
											import(`@/views/account/reporting/tir/6-tir-rh/ReportPageTir6`),
									},
									{
										path: ':id/edit',
										name: '6-tir-rh-edit',
										//meta: {accessList: ['change_reporting-5rh']},
										props: {
											statusPage: 'edit',
										},
										component: () =>
											import(`@/views/account/reporting/tir/6-tir-rh/ReportPageTir6`),
									},
								],
							},
							{
								path: '7-tir-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '7-tir-rh-index',
										//meta: {accessList: ['read_reporting-5rh']},
										component: () => import(`@/views/account/reporting/tir/7-tir-rh/index`),
									},
									{
										path: 'list',
										name: '7-tir-rh-list',
										component: {
											render: (h) => h('router-view'),
										},
										children: [
											{
												path: ':id',
												name: '7-tir-rh-archive',
												meta: { accessList: ['change_reporting-7-tir-rh'] },
												props: {
													statusPage: 'archive',
												},
												component: () => import(`@/views/account/reporting/tir/7-tir-rh/list`),
											},
										],
									},
								],
							},
							{
								path: '8-tir-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '8-tir-rh-index',
										//meta: {accessList: ['read_reporting-5rh']},
										component: () => import(`@/views/account/reporting/tir/8-tir-rh/index`),
									},
									{
										path: 'list',
										name: '8-tir-rh-list',
										component: {
											render: (h) => h('router-view'),
										},
										children: [
											{
												path: ':id',
												name: '8-tir-rh-archive',
												meta: { accessList: ['change_reporting-8-tir-rh'] },
												props: {
													statusPage: 'archive',
												},
												component: () => import(`@/views/account/reporting/tir/8-tir-rh/list`),
											},
										],
									},
								],
							},
							{
								path: '9-tir-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '9-tir-rh-index',
										//meta: {accessList: ['read_reporting-5rh']},
										component: () => import(`@/views/account/reporting/tir/9-tir-rh/index`),
									},
									{
										path: 'list',
										name: '9-tir-rh-list',
										component: {
											render: (h) => h('router-view'),
										},
										children: [
											{
												path: ':id',
												name: '9-tir-rh-archive',
												meta: { accessList: ['change_reporting-9-tir-rh'] },
												props: {
													statusPage: 'archive',
												},
												component: () => import(`@/views/account/reporting/tir/9-tir-rh/list`),
											},
										],
									},
								],
							},
							{
								path: '10-tir-rh',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: '10-tir-rh-index',
										//meta: {accessList: ['read_reporting-5rh']},
										component: () => import(`@/views/account/reporting/tir/10-tir-rh/index`),
									},
									{
										path: 'list',
										name: '10-tir-rh-list',
										component: {
											render: (h) => h('router-view'),
										},
										children: [
											{
												path: ':id',
												name: '10-tir-rh-archive',
												meta: { accessList: ['change_reporting-10-tir-rh'] },
												props: {
													statusPage: 'archive',
												},
												component: () => import(`@/views/account/reporting/tir/10-tir-rh/list`),
											},
										],
									},
								],
							},
							{
								path: 'aqua/:form([1-6])',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: 'aqua-subject-list',
										meta: { accessList: ['read_reporting-aqua'] },
										props: { scope: 'subject' },
										component: () => import(`@/views/account/reporting/aqua/index`),
									},
									{
										path: 'create',
										name: 'aqua-subject-create',
										meta: { accessList: ['change_reporting-aqua'] },
										props: { scope: 'subject', statusPage: 'create' },
										component: () => import(`@/views/account/reporting/aqua/AquaReportPage`),
									},
									{
										path: ':id(\\d+)',
										name: 'aqua-subject-show',
										meta: { accessList: ['read_reporting-aqua'] },
										props: { scope: 'subject', statusPage: 'show' },
										component: () => import(`@/views/account/reporting/aqua/AquaReportPage`),
									},
									{
										path: ':id(\\d+)/edit',
										name: 'aqua-subject-edit',
										meta: { accessList: ['change_reporting-aqua'] },
										props: { scope: 'subject', statusPage: 'edit' },
										component: () => import(`@/views/account/reporting/aqua/AquaReportPage`),
									},
								],
							},
							{
								path: 'aqua-tir-compliance',
								name: 'aqua-tir-compliance',
								meta: { accessList: ['read_reporting-aqua-tir'] },
								props: { scope: 'tir' },
								component: () => import(`@/views/account/reporting/aqua/compliance`),
							},
							{
								path: 'aqua-tir/:form([1-6])',
								component: {
									render: (h) => h('router-view'),
								},
								children: [
									{
										path: '/',
										name: 'aqua-tir-list',
										meta: { accessList: ['read_reporting-aqua-tir'] },
										props: { scope: 'tir' },
										component: () => import(`@/views/account/reporting/aqua/index`),
									},
									{
										path: 'summary',
										name: 'aqua-tir-summary',
										meta: { accessList: ['read_reporting-aqua-tir'] },
										props: { scope: 'tir' },
										component: () => import(`@/views/account/reporting/aqua/summary`),
									},
									{
										path: ':id(\\d+)',
										name: 'aqua-tir-show',
										meta: { accessList: ['read_reporting-aqua-tir'] },
										props: { scope: 'tir', statusPage: 'show' },
										component: () => import(`@/views/account/reporting/aqua/AquaReportPage`),
									},
								],
							},
						],
					},
					{
						path: 'power-reservoir/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'PowerReservoirManagement1',
								meta: { accessList: ['read_power'] },
								component: () => import('@/views/account/power-reservoir/index'),
							},
							{
								path: 'create',
								name: 'PowerReservoirManagement2',
								meta: { accessList: ['change_power'] },
								component: () => import('@/views/account/power-reservoir/create'),
							},
							{
								path: ':id',
								name: 'PowerReservoirManagement3',
								meta: { accessList: ['read_power'] },
								component: () => import('@/views/account/power-reservoir/show'),
							},
							{
								path: ':id/edit',
								name: 'PowerReservoirManagement4',
								meta: { accessList: ['change_power'] },
								component: () => import('@/views/account/power-reservoir/edit'),
							},
						],
					},
					{
						path: 'contest/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'ContestManagement1',
								meta: { accessList: ['read_contest'] },
								component: () => import('@/views/account/contest/index'),
							},
							{
								path: 'create',
								name: 'ContestManagement2',
								meta: { accessList: ['change_contest'] },
								component: () => import('@/views/account/contest/create'),
							},
							{
								path: ':id',
								name: 'ContestManagement3',
								meta: { accessList: ['read_contest'] },
								component: () => import('@/views/account/contest/show'),
							},
						],
					},
					{
						path: 'permission/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'PermissionManagement1',
								meta: { accessList: ['read_permission'] },
								component: () => import('@/views/account/permission/index'),
							},
						],
					},
					{
						path: 'permission-list/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'PermissionCreateManagement1',
								meta: { accessList: ['create_permission'] },
								component: () => import('@/views/account/permission-list/index'),
							},
							{
								path: 'create',
								name: 'PermissionCreateManagement2',
								meta: { accessList: ['create_permission'] },
								component: () => import('@/views/account/permission-list/create'),
							},
							{
								path: ':id',
								name: 'PermissionCreateManagement3',
								meta: { accessList: ['create_permission'] },
								component: () => import('@/views/account/permission-list/show'),
							},
						],
					},
					{
						path: 'fish-book/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'FishBookManagement1',
								meta: { accessList: ['read_fish_book'] },
								component: () => import('@/views/account/fish-book/index'),
							},
							{
								path: 'create',
								name: 'FishBookManagement2',
								meta: { accessList: ['change_fish_book'] },
								component: () => import('@/views/account/fish-book/create'),
							},
							{
								path: ':id',
								name: 'FishBookManagement3',
								meta: { accessList: ['read_fish_book'] },
								component: () => import('@/views/account/fish-book/show'),
							},
							{
								path: ':id/edit',
								name: 'FishBookManagement4',
								meta: { accessList: ['change_fish_book'] },
								component: () => import('@/views/account/fish-book/edit'),
							},
						],
					},
					{
						path: 'reference-log/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'ReferenceLogManagement1',
								meta: { accessList: ['read_reference'] },
								component: () => import('@/views/account/reference-log/index'),
							},
							{
								path: ':userId',
								name: 'ReferenceLogManagement2',
								meta: { accessList: ['read_reference'] },
								component: () => import('@/views/account/reference-log/show'),
							},
						],
					},
					{
						path: 'read-grown-all/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'ReadGrownAllManagement1',
								meta: { accessList: ['read_grown_all'] },
								component: () => import('@/views/account/read-grown-all/index'),
							},
							{
								path: ':userId',
								name: 'ReadGrownAllManagement2',
								meta: { accessList: ['read_grown_all'] },
								component: () => import('@/views/account/read-grown-all/show'),
							},
						],
					},
					{
						path: 'fine/',
						name: 'FineManagement',
						meta: { accessList: ['read_fine'] },
						component: () => import('@/views/account/fine/index'),
					},
					{
						path: 'prescription/',
						name: 'PrescriptionManagement',
						meta: { accessList: ['read_fine'] },
						component: () => import('@/views/account/fine/prescription'),
					},
					{
						path: 'spv-check/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								meta: { accessList: ['spv_check'] },
								component: () => import('@/views/account/spv-check/index'),
								children: [
									{
										path: '/',
										name: 'SpvCheckTirPermissions',
										component: () => import('@/views/account/spv-check/permissions'),
									},
									{
										path: 'history',
										name: 'SpvCheckTirHistory',
										component: () => import('@/views/account/spv-check/history'),
									},
									{
										path: 'comparison',
										name: 'SpvCheckTirComparison',
										meta: { accessList: ['spv_check'], goOnly: true },
										beforeEnter: (to, from, next) => {
											const user = $store.getters._getUserObject
											const roleName = user && user.role && user.role.name
											if (['go', 'go_manager', 'go_check'].includes(roleName)) {
												next()
											} else {
												next('/' + to.params.lang + '/account/spv-check/')
											}
										},
										component: () => import('@/views/account/spv-check/comparison'),
									},
								],
							},
						],
					},
					{
						path: 'mastering/',
						name: 'MasteringManagement',
						meta: { accessList: ['read_mastering'] },
						component: () => import('@/views/account/mastering/index'),
					},
					{
						path: 'reserve-fund/',
						name: 'ReserveFundManagement',
						meta: { accessList: ['read_reserve_fund'] },
						component: () => import('@/views/account/reserve-fund/index'),
					},
					{
						path: 'news',
						name: 'news',
						meta: { accessList: [] },
						component: () => import('@/views/account/news'),
					},
					{
						path: 'system-updates',
						name: 'SystemUpdatesAdmin',
						meta: { accessList: ['manage_system_updates'] },
						component: () => import('@/views/account/system-updates/index.vue'),
					},
					{
						path: 'system-updates/create',
						name: 'SystemUpdatesCreate',
						meta: { accessList: ['manage_system_updates'] },
						component: () => import('@/views/account/system-updates/form.vue'),
					},
					{
						path: 'system-updates/:id/edit',
						name: 'SystemUpdatesEdit',
						meta: { accessList: ['manage_system_updates'] },
						component: () => import('@/views/account/system-updates/form.vue'),
					},
					{
						path: 'system-update-categories',
						name: 'SystemUpdateCategories',
						meta: { accessList: ['manage_system_update_categories'] },
						component: () => import('@/views/account/system-updates/categories.vue'),
					},
					{
						path: 'contacts',
						name: 'Contacts',
						meta: { accessList: [] },
						component: () => import('@/views/account/contacts'),
					},
					{
						path: 'video',
						name: 'Video',
						meta: { accessList: [] },
						component: () => import('@/views/account/video'),
					},
					{
						path: 'integration/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: 'easu-check',
								name: 'EASUCheck',
								meta: { accessList: ['change_role'] },
								component: () => import('@/views/account/integration/EASUCheck.vue'),
							},
							{
								path: 'customs-info',
								name: 'CustomsInfo',
								meta: { accessList: ['change_role'] },
								component: () => import('@/views/account/integration/CustomsInfo.vue'),
							},
						],
					},
					{
						path: 'report-analytics',
						name: 'ReportAnalyticsManagement',
						meta: { accessList: ['change_role'] },
						component: () => import('@/views/account/report-analytics/index.vue'),
					},
					{
						path: 'customs/',
						name: 'CustomsManagement',
						meta: { accessList: ['read_customs'] },
						component: () => import('@/views/account/customs/index'),
					},
					{
						path: 'customs-analytics/',
						name: 'CustomsAnalytics',
						meta: { accessList: ['read_customs'] },
						component: () => import('@/views/account/customs/analytics'),
					},
					{
						path: 'diagram-analytics/',
						name: 'DiagramAnalytics',
						meta: { accessList: ['read_diagram_analytics'] },
						component: () => import('@/views/account/diagram-analytics/index'),
					},
					{
						path: 'gears-analytics/',
						name: 'GearsAnalytics',
						// accessList повторяет гейт эндпоинта. Показывать страницу можно только
						// ГО: `read_analytic` засеян и роли `declarer`, а дашборд считает по всей
						// стране — отсев по `go_menu` живёт в сайдбаре.
						meta: { accessList: ['read_analytic'] },
						component: () => import('@/views/account/gears-analytics/index'),
					},
					{
						path: 'trade/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'TradeList',
								meta: { accessList: ['read_trade'] },
								component: () => import('@/views/account/trade/index'),
							},
							{
								path: 'create',
								name: 'TradeCreate',
								meta: { accessList: ['change_trade'] },
								component: () => import('@/views/account/trade/create'),
							},
							{
								path: ':id',
								name: 'TradeShow',
								meta: { accessList: ['change_trade'] },
								props: {
									statusPage: 'show',
								},
								component: () => import('@/views/account/trade/create'),
							},
							{
								path: ':id/edit',
								name: 'TradeEdit',
								meta: { accessList: ['change_trade'] },
								component: () => import('@/views/account/trade/create'),
							},
						],
					},
					{
						path: 'melioration/',
						component: {
							render: (h) => h('router-view'),
						},
						children: [
							{
								path: '/',
								name: 'MeliorationList',
								meta: { accessList: ['read_trade'] },
								component: () => import('@/views/account/melioration/index'),
							},
							{
								path: 'create',
								name: 'MeliorationCreate',
								meta: { accessList: ['change_trade'] },
								component: () => import('@/views/account/melioration/create'),
							},
							{
								path: ':id',
								name: 'MeliorationShow',
								meta: { accessList: ['change_trade'] },
								props: {
									statusPage: 'show',
								},
								component: () => import('@/views/account/melioration/create'),
							},
							{
								path: ':id/edit',
								name: 'MeliorationEdit',
								meta: { accessList: ['change_trade'] },
								component: () => import('@/views/account/melioration/create'),
							},
						],
					},
				],
			},
			{
				path: '',
				component: () => import('@/views/Index.vue'),
				children: [
					{
						path: '/',
						name: 'Home',
						component: () => import('@/views/main/pages/index.vue'),
					},
					{
						path: 'news',
						component: () => import('@/views/News/AllNews.vue'),
					},
					{
						path: 'updates',
						name: 'SystemUpdates',
						component: () => import('@/views/system-updates/index.vue'),
					},
					{
						path: 'updates/:id',
						name: 'SystemUpdate',
						component: () => import('@/views/system-updates/show.vue'),
					},
					{
						path: 'faq',
						component: () => import('@/views/faq/pages/index.vue'),
					},
					{
						path: 'description/:id',
						component: () => import('@/views/News/NewsDescription.vue'),
					},
					{
						path: 'contact',
						component: () => import('@/views/Contact/index.vue'),
					},
					{
						path: 'sitemap',
						component: () => import('@/views/Sitemap/index.vue'),
					},
				],
			},
			{
				path: '',
				component: () => import('@/views/IndexAuth.vue'),
				children: [
					{
						path: 'login',
						name: 'Auth',
						component: () => import('@/views/Auth.vue'),
					},
					{
						path: 'recovery',
						name: 'Recovery',
						component: () => import('@/views/AuthRecovery.vue'),
					},
					{
						path: 'password/reset/:token',
						name: 'ResetPassword1',
						component: () => import('@/views/AuthPassword.vue'),
					},
					{
						path: 'password/auth/:token',
						name: 'ResetPassword2',
						component: () => import('@/views/Auth2Password.vue'),
					},
					{
						path: 'registration',
						name: 'registration',
						component: () => import('@/views/registration/pages/registration.vue'),
					},
					{
						path: '404',
						name: '404',
						component: () => import('@/views/NotFound.vue'),
					},
					{
						path: '*',
						redirect: '404',
					},
				],
			},
		],
	},
]
